import {Fragment} from "react"
import styled from "styled-components"
import {useDeleteSessionByIndex, useFindUserSessionById} from "hooks/query/user-query"
import {useParams} from "react-router-dom"
import {showNotification} from "common/Notification"
import dayjs from "dayjs"

const dateFormat = "YYYY/MM/DD HH:mm:ss"
export function UpdateUserSession() {
    const {id} = useParams()
    const {data: sessions} = useFindUserSessionById(id)
    const deleteMutate = useDeleteSessionByIndex()

    const deleteSession = (idx: number) => {
        showNotification("현재 기능을 지원하지 않습니다")
        return
        // if (!window.confirm("해당 세션을 강제로 로그아웃 하시겠습니까?")) return
        // if (!id) {
        //     showNotification("선택된 사용자가 없습니다")
        //     return
        // }
        // deleteMutate.mutate({id, index: idx}, {
        //     onSuccess: () => {
        //         showNotification("선택된 세션이 로그아웃 되었습니다", NotificationType.SUCCESS)
        //     },
        //     onError: () => {
        //         showNotification("세션 로그아웃중 오류가 발생하였습니다")
        //     }
        // })
    }

    return (
        <Fragment>
            <Header className="flex flex-row mt-7 pb-3">
                <div className="basis-1/6">Ip Addr</div>
                <div className="basis-1/6">시작</div>
                <div className="basis-1/6">최근접속</div>
                <div className="basis-2/6">클라이언트</div>
                <div className="basis-1/6">관리</div>
            </Header>
            {sessions?.map((session, idx) => {
                const {username, userId, clients, ipAddress, lastAccess, start} = session
                const clientKeys = Object.keys(clients)
                // @ts-ignore
                const clientNames = clientKeys.map<string>(key => clients[key] || "").join(",")
                const startTime =  dayjs(start).format(dateFormat)
                const lastAccessTime = dayjs(lastAccess).format(dateFormat)
                return (
                    <Body className="flex flex-row" key={idx}>
                        <Item className="basis-1/6">{ipAddress}</Item>
                        <Item className="basis-1/6">{startTime}</Item>
                        <Item className="basis-1/6">{lastAccessTime}</Item>
                        <Item className="basis-2/6">{clientNames}</Item>
                        <Item className="basis-1/6">
                            <button className="button is-link is-small mt-3" onClick={() => deleteSession(idx)}>Logout
                            </button>
                        </Item>
                    </Body>
                )
            })}

        </Fragment>
    )
}

const Header = styled.div`
  vertical-align: middle;
  text-align: center;
  color: #a0aec0;
  font-size: .75rem;
  border: 0;
  background: #fff;
  border-bottom: 1px #E2E8F0 solid;
`

const Body = styled.div`
  vertical-align: middle;
  color: #666;
  font-size: 0.9rem;
  text-align: center !important;
  border-bottom: 1px solid #E2E8F0;
`

const Item = styled.div`
  text-align: center;
  line-height: 45px;
  min-height: 45px;
  font-weight: 400;
  vertical-align: middle;
  padding: 2px;
`